export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '/placeholder.png';
  
  // Check if we're in production based on the current hostname
  const isProduction = window.location.hostname === 'planamelie-frontend.onrender.com';
  
  // Use the appropriate base URL
  const baseUrl = isProduction
    ? 'https://planamelie.onrender.com'
    : process.env.REACT_APP_API_URL || 'http://localhost:5000';

  // If it's an absolute URL that's not from our domains, return it as is
  if (imageUrl.startsWith('http')) {
    // Convert any development/staging URLs to use current baseUrl
    const urlObj = new URL(imageUrl);
    if (urlObj.pathname.startsWith('/uploads/')) {
      return `${baseUrl}${urlObj.pathname}`;
    }
    return imageUrl;
  }

  // Clean the image URL by removing any leading slashes
  let cleanImageUrl = imageUrl
    .replace(/^\/+/g, '') // Remove leading slashes
    .replace(/\/+/g, '/'); // Replace multiple slashes with single slash

  // Ensure the path starts with uploads/activities if it doesn't already
  if (!cleanImageUrl.startsWith('uploads')) {
    cleanImageUrl = cleanImageUrl.startsWith('activities') 
      ? `uploads/${cleanImageUrl}`
      : `uploads/activities/${cleanImageUrl}`;
  }

  // Construct the final URL
  return `${baseUrl}/${cleanImageUrl}`;
}; 